export default {
    path:'/project/detail',
    mapPath:'/project/detail',
    component: require('./index').default,
    props: true,
    parent:'root',
    name:"projectDetail",
    meta:{
        title:'项目详情'
    }
};